import { render, staticRenderFns } from "./r-smart-offer-bundle-hidden-temple.vue?vue&type=template&id=6515929d"
import script from "./r-smart-offer-bundle-hidden-temple.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-hidden-temple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6515929d')) {
      api.createRecord('6515929d', component.options)
    } else {
      api.reload('6515929d', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-hidden-temple.vue?vue&type=template&id=6515929d", function () {
      api.rerender('6515929d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-hidden-temple/r-smart-offer-bundle-hidden-temple.vue"
export default component.exports